import { styled } from 'styled-components';
import { Button } from '@/shared/ui/form/button';

export const Payments = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  gap: 8px;
  margin-top: 40px;
  margin-bottom: 24px;
`;

export const Payment = styled.div`
  border-radius: 8px;
  background: #27262b;
  padding: 16px 0;
  cursor: pointer;
  position: relative;

  ${({ $isPopular }) =>
    $isPopular &&
    `
    background: #FF6601;

  `}
`;

export const DepositButton = styled.div`
  color: #edeff5;
  display: block;
  position: relative;
  ${({ $active }) =>
    !$active &&
    `
  display:none;

  `}
`;

export const WithdrawButton = styled(Button)`
  width: 100%;
  position: relative;

  ${({ $isLoading }) =>
    $isLoading &&
    `
        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 20px;
          transform: translateY(-50%);
          width: 24px;
          height: 24px;
          background-image: url('/images/icons/element-loader.svg');
          background-size: contain;
          background-repeat: no-repeat;
        }
      
    `}
`;

export const WrapperInner = styled.div`
  margin-top: 56px;
  overflow-y: scroll;
  height: 100%;
`;

export const PaymentPopular = styled.div`
  border-radius: 6px;
  border: 1px solid #161639;
  background: #ff6601;
  box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;
  position: absolute;
  padding: 3px 6px;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
`;
